import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  currencyToNumber,
  indianCurrencyFormater,
} from "../../../../helpers/functions/currencyFormater";
import { errorToast } from "../../../../react-toastfiy/toast";
import { partnerFields } from "../common/fields";
import useCreateTAOnboarding from "../hooks/useCreateTAOnboarding";

const CreateTAOnboarding = () => {
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);

  const history = useHistory();
  const location = useLocation();
  const id = location.pathname.split(":")[1];
  const data = location?.state?.data;

  const options = ["Single", "Married", "Divorced", "Widowed"];
  const {
    formData,
    setFormData,
    handleSubmit,
    setSelected,
    selected,
    buttonLoader,
    loadingTADetails,
    handleChangebussDetails,
    handleDeletePartner,
    handleClear,
    handleAddPartner,
  } = useCreateTAOnboarding({
    Userdata: data,
    taOnboardingCaseId: id ? id : "",
  });

  useEffect(() => {
    document.title = "Create TA Onboarding";
  }, []);

  // useEffect(() => {
  //   const count = parseInt(formData.noOfPartners || 0);
  //   if (!isNaN(count)) {
  //     const existingDetails = formData.partnerDetails || [];
  //     const filledDetails = [...existingDetails];
  //     for (let i = existingDetails.length; i < count; i++) {
  //       filledDetails.push({
  //         personName: "",
  //         phone: "",
  //         email: "",
  //         businessExperienceYears: "",
  //         maritalStatusOfApplicant: "",
  //         residenceType: "",
  //       });
  //     }

  //     setFormData((prev) => ({
  //       ...prev,
  //       partnerDetails: filledDetails,
  //     }));
  //   }
  // }, [formData.noOfPartners]);

  return (
    <>
      <div className="container-fluid shadow-sm">
        <div className="container">
          <div className="row">
            <div className="d-sm-block d-md-none d-lg-none d-xl-none">
              <div className="row">
                <div className="col-12">
                  <h1 style={{ fontSize: "28px" }}>{user.name}</h1>
                </div>
                <div className="col-12">
                  <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                </div>
              </div>
            </div>

            <div className="d-none d-md-block d-lg-none d-xl-none">
              <div className="row">
                <div className="col-12 col-md-6 mt-4 ">
                  <h2 className="m4">{user.name}</h2>
                </div>
                <div className="col-12 col-md-6 mt-4 mb-4">
                  <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                </div>
              </div>
            </div>

            <div className="d-none d-md-none d-lg-block d-xl-block">
              <div className="row">
                <div className="col-12 col-md-8 mt-4 ">
                  <h2 className="m4">{user.name}</h2>
                </div>
                <div className="col-12 col-md-4 mt-4 mb-4">
                  <h1 style={{ fontSize: "28px" }}>{user.role}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-2">
        <div
          className="d-flex justify-content-between justify-content-md-start"
          style={{
            zIndex: 100,
            top: 0,
            position: "sticky",
            backgroundColor: "rgb(255,255,255)",
            paddingTop: "10px",
            paddingBottom: "10px",
            marginBottom: "10px",
          }}
        >
          <i
            className="bi bi-arrow-left-circle"
            onClick={() => history.goBack()}
            style={{
              fontSize: "xx-large",
              color: "black",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          ></i>
          <div className="col-12 col-md-4 col-lg-3 col-xl-2 d-flex justify-content-center mt-2">
            {id && id !== "" ? (
              <h4>Update TA Users</h4>
            ) : (
              <h4>Create TA Users</h4>
            )}
          </div>
        </div>

        {loadingTADetails ? (
          <div>loading ... </div>
        ) : (
          <>
            {id !== "" && id !== undefined ? (
              <>
                <div className="d-flex flex-wrap justify-content-between">
                  <div className="col-12 col-md-3">
                    <div
                      className="shadow-sm p-3 mb-2 border mt-3"
                      style={{
                        backgroundColor: "rgb(255,255,255)",
                        minHeight: "21rem",
                        maxHeight: "21rem",
                      }}
                    >
                      <div className="col-12">
                        <div
                          className="col-12  text-bold"
                          style={{
                            fontWeight: 600,
                            fontFamily: "ui-monospace",
                          }}
                        >
                          Dealer Information
                        </div>
                        <div className="col-12  text-bold">
                          <div
                            style={{
                              fontWeight: 400,
                              fontFamily: "none",
                              color: "rgb(192,190,190)",
                            }}
                          >
                            ID
                          </div>
                          <div
                            className=""
                            style={{
                              fontWeight: 600,
                              fontFamily: "none",
                              marginTop: "-2px",
                            }}
                          >
                            {formData?.taOnboardingCaseId}
                          </div>
                        </div>
                        <div className="col-12  text-bold">
                          <div
                            style={{
                              fontWeight: 400,
                              fontFamily: "none",
                              color: "rgb(192,190,190)",
                            }}
                          >
                            Location
                          </div>
                          <div
                            className=""
                            style={{
                              fontWeight: 600,
                              fontFamily: "none",
                              marginTop: "-2px",
                            }}
                          >
                            {formData?.companyAddress}
                          </div>
                        </div>
                        <div className="col-12  text-bold">
                          <div
                            style={{
                              fontWeight: 400,
                              fontFamily: "none",
                              color: "rgb(192,190,190)",
                            }}
                          >
                            TA User Name
                          </div>
                          <div
                            className=""
                            style={{
                              fontWeight: 600,
                              fontFamily: "monospace",
                              marginTop: "-2px",
                            }}
                          >
                            {formData?.personName}
                          </div>
                        </div>
                        <div className="col-12  text-bold">
                          <div
                            style={{
                              fontWeight: 400,
                              fontFamily: "none",
                              color: "rgb(192,190,190)",
                            }}
                          >
                            Phone
                          </div>
                          <div
                            className=""
                            style={{
                              fontWeight: 600,
                              fontFamily: "none",
                              marginTop: "-2px",
                            }}
                          >
                            {formData?.taUserPhone}
                          </div>
                        </div>
                        <div className="col-12  text-bold">
                          <div
                            style={{
                              fontWeight: 400,
                              fontFamily: "none",
                              color: "rgb(192,190,190)",
                            }}
                          >
                            Email
                          </div>
                          <div
                            className="flex-wrap"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              wordBreak: "break-word",
                              fontWeight: 600,
                              fontFamily: "none",
                              marginTop: "-2px",
                            }}
                          >
                            {formData?.email}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-md-9"
                    style={{ marginRight: "-10px" }}
                  >
                    <div
                      className="shadow-sm p-3 mb-2 border mt-3 onBordingCard"
                      style={{
                        backgroundColor: "rgb(255,255,255)",
                        maxHeight: "21rem",
                        minHeight: "21rem",
                      }}
                    >
                      <div
                        className="col-12 mb-2 text-bold"
                        style={{
                          fontWeight: 600,
                          fontFamily: "ui-monospace",
                        }}
                      >
                        Documents Status
                      </div>
                      <div className="d-flex flex-wrap justify-content-between flex-sm-row gap-1 ">
                        <div
                          className="onBordingScreenSize"
                          style={{
                            fontSize: "10px",
                            backgroundColor: "rgb(220,252,231)",
                            color: "rgb(122,175,159)",
                          }}
                        >
                          <h5 className="text-center m-0">
                            {formData?.verified}
                          </h5>

                          <h6 className="text-center">Verified</h6>
                        </div>
                        <div
                          className="onBordingScreenSize"
                          style={{
                            fontSize: "10px",
                            fontWeight: 500,
                            backgroundColor: "rgb(254,226,226)",
                            color: "rgb(208,122,128)",
                          }}
                        >
                          <h5 className="text-center m-0">
                            {" "}
                            <h5 className="text-center m-0">
                              {formData?.rejected}
                            </h5>
                          </h5>
                          <h6 className="text-center">Rejected</h6>
                        </div>
                        <div
                          className="onBordingScreenSize"
                          style={{
                            fontSize: "10px",
                            fontWeight: 500,
                            backgroundColor: "rgb(254,216,216)",
                            color: "rgb(208,122,128)",
                          }}
                        >
                          <h5 className="text-center m-0">
                            {" "}
                            <h5 className="text-center m-0">
                              {" "}
                              {formData?.missing}
                            </h5>
                          </h5>
                          <h6 className="text-center">Missing</h6>
                        </div>
                        <div
                          className="onBordingScreenSize"
                          style={{
                            fontSize: "10px",
                            fontWeight: 500,
                            backgroundColor: "rgb(243,244,246)",
                            color: "rgb(192,172,165)",
                          }}
                        >
                          <h5 className="text-center m-0">
                            <h5 className="text-center m-0">
                              {formData?.pending}
                            </h5>
                          </h5>
                          <h6 className="text-center">Pending</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="shadow-sm p-3 mb-2 border mt-2">
                <div className="row">
                  <div className="col-12 col-md-4">
                    <span> User Name</span>:{" "}
                    <strong>{formData?.personName}</strong>
                  </div>
                  <div className="col-12 col-md-4">
                    <span> User Phone</span>:{" "}
                    <strong>{formData?.taUserPhone}</strong>
                  </div>
                  <div className="col-12 col-md-4">
                    <span> User State</span>: <strong>{formData?.state}</strong>
                  </div>
                </div>
              </div>
            )}

            <div
              className="btn-group mt-2 p-1"
              role="group"
              aria-label="Basic radio toggle button group"
              style={{
                backgroundColor: "rgb(244,244,245)",
                width: "100%",
                display: "flex",
              }}
            >
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="bussRadio"
                autoComplete="off"
                checked={selected === "buss"}
                onChange={() => setSelected("buss")}
              />
              <label
                className="btn"
                htmlFor="bussRadio"
                style={{
                  backgroundColor:
                    selected === "buss" ? "#fff" : "rgb(244,244,245)",
                  color: selected === "buss" ? "#000" : "#999",
                  fontWeight: selected === "buss" ? 500 : 400,
                  border: "0px solid #ccc",
                  borderLeft: "none",
                  borderRadius: "0",
                  padding: "6px 12px",
                  flex: 1,
                  textAlign: "center",
                }}
              >
                <i
                  className="bi bi-person"
                  style={{
                    marginRight: "6px",
                    color: selected === "buss" ? "rgb(75,107,134)" : "#ccc",
                  }}
                ></i>
                Business Details
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="docRadio"
                autoComplete="off"
                checked={selected === "doc"}
                onChange={() =>
                  errorToast("Business details must be completed first")
                }
              />
              <label
                className="btn"
                htmlFor="docRadio"
                style={{
                  backgroundColor:
                    selected === "doc" ? "#fff" : "rgb(244,244,245)",
                  color: selected === "doc" ? "#000" : "#999",
                  fontWeight: selected === "doc" ? 500 : 400,
                  border: "0px solid #ccc",
                  borderRadius: "0",
                  padding: "6px 12px",
                  flex: 1,
                  textAlign: "center",
                }}
              >
                <i
                  className="bi bi-file-earmark-text"
                  style={{
                    marginRight: "6px",
                    color: selected === "doc" ? "rgb(75,107,134)" : "#ccc",
                  }}
                ></i>
                Documents Collection
              </label>
            </div>

            <div className="shadow-sm p-3 mb-2 border mt-2">
              <div className="mt-3">
                <h5 className="mt-2">Business Details Form</h5>
                <span className="mt-2 mb-2">
                  Please provide your business information to proceed
                </span>
              </div>

              <form
                noValidate
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                {formData?.taOnboardingCaseId !== "" &&
                  formData?.isCaseBusinessDetailsRejectedByBa && (
                    <>
                      <div
                        className="mt-3 px-2 py-2"
                        style={{
                          backgroundColor: "rgb(253,241,241)",
                          color: "rgb(202,73,101)",
                          borderRadius: "6px",
                        }}
                      >
                        <span>Rejection Reason :</span>
                        <span
                          className="text-danger"
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            marginTop: "5px",
                            marginLeft: "2px",
                          }}
                        >
                          {formData?.caseBusinessDetailsRejectionReason ||
                            "N/A"}
                        </span>
                      </div>
                    </>
                  )}
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Business Information
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <span>
                              Business Type{" "}
                              <strong className="text-danger">*</strong>
                            </span>

                            <div className="form-check row mt-2">
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={
                                    formData?.businessType === "individual"
                                  }
                                  id="individual"
                                  name="businessType"
                                  onChange={() =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      businessType: "individual",
                                    }))
                                  }
                                  required
                                />
                                <label htmlFor="individual">Individual</label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={
                                    formData?.businessType === "proprietor"
                                  }
                                  id="proprietor"
                                  name="businessType"
                                  onChange={() =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      businessType: "proprietor",
                                    }))
                                  }
                                  required
                                />
                                <label htmlFor="proprietor">Proprietor</label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={
                                    formData?.businessType === "partnership"
                                  }
                                  id="partnership"
                                  name="businessType"
                                  onChange={() =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      businessType: "partnership",
                                      partnerDetails: prev?.partnerDetails
                                        ?.length
                                        ? [...prev?.partnerDetails]
                                        : [
                                          {
                                            personName: "",
                                            phone: "",
                                            email: "",
                                            residenceType: "",
                                            businessExperienceYears: "",
                                            maritalStatusOfApplicant: "",
                                          },
                                        ],
                                      noOfPartners:
                                        prev?.partnerDetails?.length === 0
                                          ? 1
                                          : prev?.partnerDetails?.length,
                                    }))
                                  }
                                  required
                                />
                                <label htmlFor="partnership">Partnership</label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={formData?.businessType === "pvt_ltd"}
                                  id="pvt_ltd"
                                  name="businessType"
                                  onChange={() =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      businessType: "pvt_ltd",
                                      partnerDetails: prev?.partnerDetails
                                        ?.length
                                        ? [...prev?.partnerDetails]
                                        : [
                                          {
                                            personName: "",
                                            phone: "",
                                            email: "",
                                            residenceType: "",
                                            businessExperienceYears: "",
                                            maritalStatusOfApplicant: "",
                                          },
                                        ],
                                      noOfPartners:
                                        prev?.partnerDetails?.length === 0
                                          ? 1
                                          : prev?.partnerDetails?.length,
                                    }))
                                  }
                                  required
                                />
                                <label htmlFor="pvt_ltd">
                                  Private limited (Pvt Ltd)
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <span>
                              Dealing In (Vehicle){" "}
                              <strong className="text-danger">*</strong>
                            </span>
                            <div className="form-check row mt-2">
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="checkbox"
                                  checked={formData?.dealingInCv}
                                  id="dealingInCv"
                                  name="dealingInCv"
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setFormData((prev) => {
                                      const updatedList = checked
                                        ? [...prev.dealingInList, "cv"]
                                        : prev.dealingInList.filter(
                                          (item) => item !== "cv"
                                        );

                                      return {
                                        ...prev,
                                        dealingInCv: checked,
                                        dealingInList: updatedList,
                                      };
                                    });
                                  }}
                                // required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="dealingInCv"
                                >
                                  CV
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="checkbox"
                                  checked={formData?.dealingInTractor}
                                  id="dealingInTractor"
                                  name="dealingInTractor"
                                  // onChange={(e) => {
                                  //   const checked = e.target.checked;
                                  //   setFormData((prev) => ({
                                  //     ...prev,
                                  //     dealingInTractor: e.target.checked,
                                  //     dealingInList: checked ? "tractor" : "",
                                  //   }));
                                  // }}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setFormData((prev) => {
                                      const updatedList = checked
                                        ? [...prev.dealingInList, "tractor"]
                                        : prev.dealingInList.filter(
                                          (item) => item !== "tractor"
                                        );

                                      return {
                                        ...prev,
                                        dealingInTractor: checked,
                                        dealingInList: updatedList,
                                      };
                                    });
                                  }}
                                // required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="dealingInTractor"
                                >
                                  Tractor
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="checkbox"
                                  checked={formData?.dealingIn2w}
                                  id="dealingIn2w"
                                  name="dealingIn2w"
                                  // onChange={(e) => {
                                  //   const checked = e.target.checked;
                                  //   setFormData((prev) => ({
                                  //     ...prev,
                                  //     dealingIn2w: checked,
                                  //     dealingInList: checked ? "2w" : "",
                                  //   }));
                                  // }}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setFormData((prev) => {
                                      const updatedList = checked
                                        ? [...prev.dealingInList, "2w"]
                                        : prev.dealingInList.filter(
                                          (item) => item !== "2w"
                                        );

                                      return {
                                        ...prev,
                                        dealingIn2w: checked,
                                        dealingInList: updatedList,
                                      };
                                    });
                                  }}
                                // required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="dealingIn2w"
                                >
                                  2 Wheeler
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          {formData?.businessType !== "" &&
                            formData?.businessType !== "individual" && (
                              <div className="col-12 col-md-6">
                                <label
                                  htmlFor="companyName"
                                  className="form-label"
                                >
                                  Business Name
                                  <strong className="text-danger">*</strong>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id={"companyName"}
                                  name={"companyName"}
                                  value={formData?.companyName}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      companyName: e?.target?.value,
                                    }));
                                  }}
                                  placeholder="Enter business name"
                                  onWheel={(e) => e.target.blur()}
                                  required
                                />
                              </div>
                            )}
                          {/* {formData?.businessType !== "" &&
                            formData?.businessType !== "proprietor" &&
                            formData?.businessType !== "individual" && (
                              <div className="col-12 col-md-6">
                                <label
                                  htmlFor="noOfPartners"
                                  className="form-label"
                                >
                                  Total Partners
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id={"noOfPartners"}
                                  name={"noOfPartners"}
                                  value={formData?.noOfPartners}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      noOfPartners: e?.target?.value,
                                    }));
                                  }}
                                  placeholder="Enter number of partners"
                                  onWheel={(e) => e.target.blur()}
                                  // required
                                  disabled
                                />
                              </div>
                            )} */}
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="businessExperienceYears"
                              className="form-label"
                            >
                              Total Business Experience (in years)
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={"businessExperienceYears"}
                              name={"businessExperienceYears"}
                              value={formData?.businessExperienceYears}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  businessExperienceYears: e?.target?.value,
                                }));
                              }}
                              placeholder="Enter business experience in years"
                              onWheel={(e) => e.target.blur()}
                              min={0}
                              required
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="vintageWithMeratractorYears"
                              className="form-label"
                            >
                              Vintage With MeraTractor (in years)
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={"vintageWithMeratractorYears"}
                              name={"vintageWithMeratractorYears"}
                              value={formData?.vintageWithMeratractorYears}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  vintageWithMeratractorYears: e?.target?.value,
                                }));
                              }}
                              placeholder="Enter years with MeraTractor"
                              onWheel={(e) => e.target.blur()}
                              min={0}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="monthlyAverageSalesUnit"
                              className="form-label"
                            >
                              Monthly Average Sales (units)
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={"monthlyAverageSalesUnit"}
                              name={"monthlyAverageSalesUnit"}
                              value={formData?.monthlyAverageSalesUnit}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  monthlyAverageSalesUnit: e?.target?.value,
                                }));
                              }}
                              placeholder="Enter average sales in units"
                              onWheel={(e) => e.target.blur()}
                              min={0}
                              required
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="monthlyAverageSalesVolume"
                              className="form-label"
                            >
                              Monthly Average Sales (volume)
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"monthlyAverageSalesVolume"}
                              name={"monthlyAverageSalesVolume"}
                              value={indianCurrencyFormater(
                                formData?.monthlyAverageSalesVolume,
                                0
                              )}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  monthlyAverageSalesVolume: currencyToNumber(
                                    e?.target?.value
                                  ),
                                }));
                              }}
                              placeholder="Enter average sales volume"
                              min={0}
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="associatedFinanciers"
                              className="form-label"
                            >
                              Associated Financiers
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"associatedFinanciers"}
                              name={"associatedFinanciers"}
                              value={formData?.associatedFinanciers}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  associatedFinanciers: e?.target?.value,
                                }));
                              }}
                              required={false}
                              placeholder="Enter associated financiers"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="brokerBackground"
                              className="form-label"
                            >
                              Broker Background
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"brokerBackground"}
                              name={"brokerBackground"}
                              value={formData?.brokerBackground}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  brokerBackground: e?.target?.value,
                                }));
                              }}
                              //   disabled={disabled}
                              placeholder="Describe broker background"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Primary Contact Details
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label htmlFor="email" className="form-label">
                              Email <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"email"}
                              name={"email"}
                              value={formData?.email}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  email: e?.target?.value.trim(),
                                }));
                              }}
                              placeholder="Enter email address"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label htmlFor="taUserPhone" className="form-label">
                              Contact Number{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]{10}"
                              maxLength={10}
                              title="Phone number should be exactly 10 digits"
                              className="form-control"
                              id={"taUserPhone"}
                              name={"taUserPhone"}
                              value={formData?.taUserPhone}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  taUserPhone: e?.target?.value,
                                }));
                              }}
                              disabled
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              }}
                              placeholder="Auto-filled contact number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          {(formData?.businessType === "individual" ||
                            formData?.businessType === "proprietor" ||
                            formData?.businessType === "") && (
                              <div className="col-12 col-md-6">
                                <label htmlFor="userPan" className="form-label">
                                  Pan Card{" "}
                                  <strong className="text-danger">*</strong>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id={"userPan"}
                                  name={"userPan"}
                                  value={formData?.userPan}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      userPan: e?.target?.value.toUpperCase(),
                                    }));
                                  }}
                                  //   disabled={disabled}
                                  placeholder="Enter PAN"
                                  onWheel={(e) => e.target.blur()}
                                  maxLength={10}
                                  pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                                  title="PAN should be in format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)"
                                  required
                                />
                              </div>
                            )}
                          {formData?.businessType !== "individual" &&
                            formData?.businessType !== "proprietor" &&
                            formData?.businessType !== "" && (
                              <div className="col-12 col-md-6">
                                <label htmlFor="firmPan" className="form-label">
                                  Firm Pan{" "}
                                  <strong className="text-danger">*</strong>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id={"firmPan"}
                                  name={"firmPan"}
                                  value={formData?.firmPan}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      firmPan: e?.target?.value.toUpperCase(),
                                    }));
                                  }}
                                  placeholder="Enter Firm PAN"
                                  onWheel={(e) => e.target.blur()}
                                  maxLength={10}
                                  pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                                  title="PAN should be in format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)"
                                  required
                                />
                              </div>
                            )}
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="maritalStatusOfApplicant"
                              className="form-label"
                            >
                              Marital Status of Applicant{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            {/* <input
                          type="text"
                          className="form-control"
                          id={"maritalStatusOfApplicant"}
                          name={"maritalStatusOfApplicant"}
                          value={formData?.maritalStatusOfApplicant}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              maritalStatusOfApplicant: e?.target?.value,
                            }));
                          }}
                          //   disabled={disabled}
                          placeholder="Select marital status"
                          onWheel={(e) => e.target.blur()}
                          required
                        /> */}
                            <select
                              className="form-select"
                              id={`maritalStatusOfApplicant`}
                              name={`maritalStatusOfApplicant`}
                              onChange={handleChangebussDetails}
                              value={formData?.maritalStatusOfApplicant}
                              required
                            >
                              <option value="">Select...</option>
                              {options.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="recommendedAmount"
                              className="form-label"
                            >
                              Recommended Amount
                            </label>
                            <select
                              className="form-select"
                              id="recommendedAmount"
                              name="recommendedAmount"
                              value={formData?.recommendedAmount || ""}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  recommendedAmount: e?.target?.value,
                                }));
                              }}
                            >
                              <option value="">Select...</option>
                              <option value="10L">10L</option>
                              <option value="12L">12L</option>
                              <option value="15L">15L</option>
                            </select>
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="residentialStabilityYears"
                              className="form-label"
                            >
                              Residential Stability In Years{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={"residentialStabilityYears"}
                              name={"residentialStabilityYears"}
                              value={formData?.residentialStabilityYears}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  residentialStabilityYears: e?.target?.value,
                                }));
                              }}
                              //   disabled={disabled}
                              placeholder="Enter residential stability in years"
                              onWheel={(e) => e.target.blur()}
                              min={0}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="companyAddress"
                              className="form-label"
                            >
                              Business Address{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <textarea
                              type="textarea"
                              className="form-control"
                              id={"companyAddress"}
                              name={"companyAddress"}
                              value={formData?.companyAddress}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  companyAddress: e?.target?.value,
                                }));
                              }}
                              //   disabled={disabled}
                              placeholder="Enter business address"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Property & Infrastructure
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="col-12 col-md-3 col-lg-4">
                            <span>
                              Residence Type{" "}
                              <strong className="text-danger">*</strong>
                            </span>
                            <div className="form-check row mt-2">
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={formData?.residenceType === "owned"}
                                  id={"owned"}
                                  name={"residenceType"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      residenceType: "owned",
                                    }));
                                  }}
                                  required
                                />
                                <label htmlFor="owned" className="form-label">
                                  Owned
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={formData?.residenceType === "rented"}
                                  id={"rented"}
                                  name={"residenceType"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      residenceType: "rented",
                                    }));
                                  }}
                                  required
                                />
                                <label htmlFor="rented" className="form-label">
                                  Rented
                                </label>
                              </div>
                            </div>
                          </div>{" "}
                          <div className="col-12 col-md-3 col-lg-4">
                            <span>
                              Office Type{" "}
                              <strong className="text-danger">*</strong>
                            </span>
                            <div className="form-check row mt-2">
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={formData?.officeType === "owned"}
                                  id={"officeTypeOwned"}
                                  name={"officeType"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      officeType: "owned",
                                    }));
                                  }}
                                  required
                                />
                                <label
                                  htmlFor="officeTypeOwned"
                                  className="form-label"
                                >
                                  Owned
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={formData?.officeType === "rented"}
                                  id={"officeTypeRented"}
                                  name={"officeType"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      officeType: "rented",
                                    }));
                                  }}
                                  required
                                />
                                <label
                                  htmlFor="officeTypeRented"
                                  className="form-label"
                                >
                                  Rented
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>
                              Yard For Stocking The Vehicle{" "}
                              <strong className="text-danger">*</strong>
                            </span>
                            <div className="form-check row mt-2">
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={
                                    formData?.yardForStocking === "owned"
                                  }
                                  id={"yardForStocking"}
                                  name={"yardForStocking"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      yardForStocking: "owned",
                                    }));
                                  }}
                                  required
                                />
                                <label
                                  htmlFor="yardForStocking"
                                  className="form-label"
                                >
                                  Owned
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-check-input me-2"
                                  type="radio"
                                  checked={
                                    formData?.yardForStocking === "rented"
                                  }
                                  id={"yardForStockingRented"}
                                  name={"yardForStocking"}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      yardForStocking: "rented",
                                    }));
                                  }}
                                  required
                                />
                                <label
                                  htmlFor="yardForStockingRented"
                                  className="form-label"
                                >
                                  Rented
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          {/* <div className="col-12 col-md-6">
                        <label
                          htmlFor="residentialStabilityYears"
                          className="form-label"
                        >
                          Residential Stability In Years{" "}
                          <strong className="text-danger">*</strong>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id={"residentialStabilityYears"}
                          name={"residentialStabilityYears"}
                          value={formData?.residentialStabilityYears}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              residentialStabilityYears: e?.target?.value,
                            }));
                          }}
                          //   disabled={disabled}
                          placeholder="Enter residential stability in years"
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div> */}
                          <div className="col-12 col-md-6">
                            <label htmlFor="yardDetails" className="form-label">
                              Details Of Associated Yard
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"yardDetails"}
                              name={"yardDetails"}
                              value={formData?.yardDetails}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  yardDetails: e?.target?.value,
                                }));
                              }}
                              //   disabled={disabled}
                              placeholder="Enter yard details"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        References
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="reference1Name"
                              className="form-label"
                            >
                              Reference 1 Name{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"reference1Name"}
                              name={"reference1Name"}
                              value={formData?.reference1Name}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  reference1Name: e?.target?.value,
                                }));
                              }}
                              placeholder="Enter reference 1 name"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="reference1Phone"
                              className="form-label"
                            >
                              Reference 1 Contact Number{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]{10}"
                              maxLength={10}
                              title="Phone number should be exactly 10 digits"
                              className="form-control"
                              id={"reference1Phone"}
                              name={"reference1Phone"}
                              value={formData?.reference1Phone}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  reference1Phone: e?.target?.value,
                                }));
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              }}
                              placeholder="Enter reference 1 contact number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="reference2Name"
                              className="form-label"
                            >
                              Reference 2 Name{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={"reference2Name"}
                              name={"reference2Name"}
                              value={formData?.reference2Name}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  reference2Name: e?.target?.value,
                                }));
                              }}
                              placeholder="Enter reference 2 name"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="reference2Phone"
                              className="form-label"
                            >
                              Reference 2 Contact Number{" "}
                              <strong className="text-danger">*</strong>
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]{10}"
                              maxLength={10}
                              title="Phone number should be exactly 10 digits"
                              className="form-control"
                              id={"reference2Phone"}
                              name={"reference2Phone"}
                              value={formData?.reference2Phone}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  reference2Phone: e?.target?.value,
                                }));
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              }}
                              placeholder="Enter reference 1 contact number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {(formData.businessType === "partnership" ||
                    formData.businessType === "pvt_ltd") && (
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFive">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            Partnership Details
                          </button>
                        </h2>
                        <div
                          id="collapseFive"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {formData?.partnerDetails?.map((partner, index) => (
                              <div key={index}>
                                <div className="d-flex flex-wrap justify-content-between">
                                  <h6 className="mt-2 mb-2 text-start">
                                    Partner {index + 1} Details
                                  </h6>

                                  {formData?.taOnboardingCaseId !== "" &&
                                    partner?.partnerID ? (
                                    <div className="col-3 text-end mt-2">
                                      <i
                                        className="bi bi-trash"
                                        style={{
                                          fontSize: "20px",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) =>
                                          handleDeletePartner(
                                            e,
                                            formData.taOnboardingCaseId,
                                            partner.partnerID
                                          )
                                        }
                                      ></i>
                                    </div>
                                  ) : (
                                    <h6
                                      className="mt-2 mb-2 text-start"
                                      onClick={() => {
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you really want to remove this partner?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#d33",
                                          cancelButtonColor: "#3085d6",
                                          confirmButtonText: "Yes, delete it!",
                                          showLoaderOnConfirm: true,
                                          preConfirm: () => {
                                            return new Promise((resolve) => {
                                              // Simulate async deletion
                                              setTimeout(() => {
                                                setFormData((prev) => {
                                                  const updatedPartnerDetails = prev.partnerDetails.filter(
                                                    (_, i) => i !== index
                                                  );
                                                  return {
                                                    ...prev,
                                                    partnerDetails: updatedPartnerDetails,
                                                    noOfPartners: updatedPartnerDetails.length,
                                                  };
                                                });
                                                resolve();
                                              }, 1000); // 1-second delay to simulate loading
                                            });
                                          },
                                          allowOutsideClick: () =>
                                            !Swal.isLoading(),
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            Swal.fire(
                                              "Deleted!",
                                              "The partner has been removed.",
                                              "success"
                                            );
                                          }
                                        });
                                      }}
                                    >
                                      <i
                                        className="bi bi-trash"
                                        style={{
                                          fontSize: "20px",
                                          cursor: "pointer",
                                        }}
                                      ></i>
                                    </h6>
                                  )}
                                </div>

                                <div className="row">
                                  {partnerFields.map(
                                    ({
                                      id,
                                      label,
                                      type,
                                      options = [],
                                      placeholder,
                                      required,
                                      inputMode,
                                      pattern,
                                      maxLength,
                                    }) => (
                                      <div
                                        className="col-12 col-md-6"
                                        key={`${id}_${index}`}
                                      >
                                        <label
                                          htmlFor={`${id}_${index}`}
                                          className="form-label mt-2"
                                        >
                                          {label}
                                          {required && (
                                            <strong className="text-danger">
                                              *
                                            </strong>
                                          )}
                                        </label>

                                        {type === "select" ? (
                                          <select
                                            className="form-select"
                                            id={`${id}_${index}`}
                                            name={`partner_${index + 1}_${id}`}
                                            onChange={handleChangebussDetails}
                                            value={partner[id] || ""}
                                            required={required}
                                          >
                                            <option value="">Select...</option>
                                            {options.map((opt) => (
                                              <option key={opt} value={opt}>
                                                {opt}
                                              </option>
                                            ))}
                                          </select>
                                        ) : type === "radio" ? (
                                          <div>
                                            {options.map((opt) => (
                                              <div
                                                className="form-check form-check-inline"
                                                key={opt}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name={`partner_${index + 1
                                                    }_${id}`}
                                                  id={`${id}_${index}_${opt}`}
                                                  value={opt}
                                                  checked={partner[id] === opt}
                                                  onChange={(e) =>
                                                    handleChangebussDetails(
                                                      e,
                                                      id,
                                                      type
                                                    )
                                                  }
                                                  required={required}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor={`${id}_${index}_${opt}`}
                                                >
                                                  {opt}
                                                </label>
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <input
                                            className="form-control"
                                            id={`${id}_${index}`}
                                            type={type || "text"}
                                            name={`partner_${index + 1}_${id}`}
                                            value={
                                              id === "email"
                                                ? partner[id].trim() || ""
                                                : partner[id] || ""
                                            }
                                            placeholder={placeholder}
                                            onChange={(e) =>
                                              handleChangebussDetails(e, id, type)
                                            }
                                            required={required}
                                            onInput={(e) => {
                                              id === "phone" &&
                                                (e.target.value =
                                                  e.target.value.replace(
                                                    /[^0-9]/g,
                                                    ""
                                                  ));
                                            }}
                                            {...(id === "phone" && {
                                              maxLength: 10,
                                              pattern: "[0-9]{10}",
                                              inputMode: "numeric",
                                              title:
                                                "Phone number should be exactly 10 digits",
                                            })}
                                          />
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                                <hr className="soften mt-4 mb-3" />
                              </div>
                            ))}

                            <div className="d-flex align-items-center justify-content-end ">
                              <button
                                type="button"
                                className="btn btn-primary gap-2"
                                onClick={handleAddPartner}
                              >
                                <i
                                  className="bi bi-plus"
                                  style={{ fontSize: "22px" }}
                                ></i>
                                <span>Add Partner</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
                <div className="d-flex justify-content-end">
                  {!id && (id === "" || id === undefined) && (
                    <div
                      className=" mt-2"
                      style={{
                        bottom: -23,
                        zIndex: 5,
                        position: "sticky",
                        backgroundColor: "rgb(255,255,255)",
                      }}
                    >
                      <button
                        className="btn btn-warning me-2"
                        type="button"
                        onClick={(e) => handleClear(e)}
                      >
                        <i class="bi bi-arrow-clockwise"></i>
                        Clear
                      </button>
                    </div>
                  )}

                  <div
                    className="mt-2"
                    style={{
                      bottom: -23,
                      zIndex: 5,
                      position: "sticky",
                      backgroundColor: "rgb(255,255,255)",
                    }}
                  >
                    {buttonLoader ? (
                      <button
                        className="btn btn-primary"
                        type="button"
                        disabled
                        id="loadingBtnTp"
                      >
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                    ) : id && id !== "" ? (
                      <button
                        className="btn btn-success"
                        type="submit"
                      // onClick={(e) => handleSubmit(e)}
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        className="btn btn-success"
                        type="submit"
                      // onClick={(e) => handleSubmit(e)}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CreateTAOnboarding;
